import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { login as _login, get_captcha, get_access_token, send_code as _send_code, update_2fa as _update_2fa } from '../../services/IndexPage';
import { chartColor } from "../../utils/commonConsts";
import { get_logo as _get_logo, all_company_update as _all_company_update } from "../../services/Company/companyS";
import { menuInfo } from '../../utils/commonMenuData';
import { BossMessage } from "../../components/Common/BossMessages";
export default {
  namespace: "indexPage",
  state: {
    result: false,
    menuInfo: {},
    role: "",
    ifCaptchaShow: false,
    captchaUrl: "",
    logo_url: "",
    logo_pic: '',
    aaa: '' // need_change_password:false
  },
  effects: {
    login: function login(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData, role, roleColor, menuInfodata, data, model, backData1;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return put({
                type: "update",
                payload: {
                  result: false
                }
              });
            case 2:
              _context.next = 4;
              return call(_login, payload);
            case 4:
              backData = _context.sent;
              if (!backData.success) {
                _context.next = 68;
                break;
              }
              if (!backData.access_token) {
                _context.next = 14;
                break;
              }
              _context.next = 9;
              return put({
                type: "update",
                payload: {
                  result: backData.success,
                  access_token: backData.access_token,
                  telNumber: backData.result
                }
              });
            case 9:
              sessionStorage.setItem("access_token", backData.access_token);
              sessionStorage.setItem("telNumber", backData.result);
              sessionStorage.setItem("loginParam", JSON.stringify(payload));
              _context.next = 66;
              break;
            case 14:
              role = "";
              roleColor = "";
              _context.t0 = backData.role;
              _context.next = _context.t0 === "company" ? 19 : _context.t0 === "companystaff" ? 22 : _context.t0 === "supercxpbusiness" ? 25 : _context.t0 === "supercxptechnology" ? 28 : _context.t0 === "supercxptechsupport" ? 31 : _context.t0 === "supercxpbizadmin" ? 34 : _context.t0 === "supercxptechadmin" ? 37 : _context.t0 === "supercxpadmin" ? 40 : 43;
              break;
            case 19:
              role = "企业管理员";
              roleColor = chartColor[1];
              return _context.abrupt("break", 44);
            case 22:
              role = "普通用户";
              roleColor = chartColor[10];
              return _context.abrupt("break", 44);
            case 25:
              role = "商务";
              roleColor = chartColor[2];
              return _context.abrupt("break", 44);
            case 28:
              role = "运维";
              roleColor = chartColor[4];
              return _context.abrupt("break", 44);
            case 31:
              role = "技术支持";
              roleColor = chartColor[5];
              return _context.abrupt("break", 44);
            case 34:
              role = "商务主管";
              roleColor = chartColor[6];
              return _context.abrupt("break", 44);
            case 37:
              role = "技术支持主管";
              roleColor = chartColor[7];
              return _context.abrupt("break", 44);
            case 40:
              role = "账号管理员";
              roleColor = chartColor[8];
              return _context.abrupt("break", 44);
            case 43:
              return _context.abrupt("break", 44);
            case 44:
              menuInfodata = {};
              if (sessionStorage.getItem('companyonlyshow') == 'true') {
                menuInfodata = menuInfo['menuonlyshow'];
              } else {
                menuInfodata = menuInfo[backData.role];
              }
              if (backData.enable_export_switch === 1 && (backData.role === 'company' || backData.role === 'companystaff')) {
                data = menuInfodata['configuration'][0].sub.filter(function (item) {
                  return item.id === 313;
                });
                if (data.length <= 0) {
                  menuInfodata['configuration'][0].sub.push({
                    "name": "出口方向",
                    "level": 3,
                    "parent_id": 31,
                    "path": "bi2502",
                    "id": 313,
                    "icon": null
                  }, {
                    "name": "链路带宽",
                    "level": 3,
                    "parent_id": 31,
                    "path": "bi2503",
                    "id": 314,
                    "icon": null
                  });
                }
              }
              _context.next = 49;
              return put({
                type: "update",
                payload: {
                  result: backData.success,
                  // menuInfo:backData.result,
                  menuInfo: menuInfodata,
                  role: role,
                  rolecname: backData.role,
                  companyNm: backData.company_name,
                  roleColor: roleColor,
                  access_token: '',
                  telNumber: '' // need_change_password:backData.need_change_password
                }
              });
            case 49:
              sessionStorage.setItem("loginParam", "{}");
              sessionStorage.setItem("verify_channel", backData.verify_channel ? backData.verify_channel : '');
              sessionStorage.setItem("is_active", backData.is_active);
              sessionStorage.setItem("access_token", '');
              sessionStorage.setItem("telNumber", '');
              sessionStorage.setItem("companyId", backData.company_id.toString());
              sessionStorage.setItem('company_uid', backData.company_uid);
              sessionStorage.setItem("role", backData.role);
              sessionStorage.setItem("roleName", role);
              sessionStorage.setItem("companyNm", backData.company_name);
              sessionStorage.setItem("roleColor", roleColor);
              sessionStorage.setItem("first_login", backData.first_login.toString());
              sessionStorage.setItem("person_id", backData.person_id.toString());
              sessionStorage.setItem('expire_date', backData.expire_date);
              sessionStorage.setItem('near_expire', backData.near_expire.toString());
              sessionStorage.setItem('menuInfo', JSON.stringify(menuInfodata));
              sessionStorage.setItem('need_change_password', backData.need_change_password.toString());
            case 66:
              _context.next = 77;
              break;
            case 68:
              model = _Modal.error({
                title: "Login failed",
                content: backData.result
              });
              setTimeout(function () {
                return model.destroy();
              }, 2000);
              if (sessionStorage.getItem('access_token')) {
                _context.next = 77;
                break;
              }
              _context.next = 73;
              return call(get_captcha, {});
            case 73:
              backData1 = _context.sent;
              if (!backData) {
                _context.next = 77;
                break;
              }
              _context.next = 77;
              return put({
                type: "update",
                payload: {
                  ifCaptchaShow: true,
                  captchaUrl: backData1.result
                }
              });
            case 77:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    reloadCaptcha: function reloadCaptcha(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(get_captcha, {});
            case 2:
              backData = _context2.sent;
              if (!backData.success) {
                _context2.next = 6;
                break;
              }
              _context2.next = 6;
              return put({
                type: "update",
                payload: {
                  captchaUrl: backData.result
                }
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    get_logo: function get_logo(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(_get_logo, payload);
            case 2:
              backData = _context3.sent;
              _context3.prev = 3;
              if (!backData.success) {
                _context3.next = 7;
                break;
              }
              _context3.next = 7;
              return put({
                type: "update",
                payload: {
                  logo_url: backData.result
                }
              });
            case 7:
              _context3.next = 12;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](3);
              console.error(_context3.t0);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[3, 9]]);
      })();
    },
    get_logoPic: function get_logoPic(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(_get_logo, payload);
            case 2:
              backData = _context4.sent;
              _context4.prev = 3;
              if (!backData.success) {
                _context4.next = 7;
                break;
              }
              _context4.next = 7;
              return put({
                type: "update",
                payload: {
                  logo_pic: backData.result
                }
              });
            case 7:
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              console.error(_context4.t0);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[3, 9]]);
      })();
    },
    all_company_update: function all_company_update(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_all_company_update, payload);
            case 2:
              backData = _context5.sent;
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    hideCaptcha: function hideCaptcha(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return put({
                type: "update",
                payload: {
                  ifCaptchaShow: false
                }
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    send_code: function send_code(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData2, backData, backData3, _backData, _backData2;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!payload.access_token) {
                _context7.next = 23;
                break;
              }
              _context7.next = 3;
              return call(_send_code, payload);
            case 3:
              backData2 = _context7.sent;
              if (backData2.success) {
                _context7.next = 21;
                break;
              }
              if (!(backData2.code == 400)) {
                _context7.next = 20;
                break;
              }
              _context7.next = 8;
              return call(get_access_token, {
                username: payload.username
              });
            case 8:
              backData = _context7.sent;
              if (backData.success) {
                _context7.next = 13;
                break;
              }
              sessionStorage.setItem('errcode', backData2 && backData2.result ? backData2.result : '');
              _context7.next = 18;
              break;
            case 13:
              sessionStorage.setItem("access_token", backData.access_token);
              _context7.next = 16;
              return call(_send_code, {
                access_token: backData.access_token
              });
            case 16:
              backData3 = _context7.sent;
              if (!backData3.success) {
                sessionStorage.setItem('errcode', backData3 && backData3.result ? backData3.result : '');
              }
            case 18:
              _context7.next = 21;
              break;
            case 20:
              sessionStorage.setItem('errcode', backData2 && backData2.result ? backData2.result : '');
            case 21:
              _context7.next = 34;
              break;
            case 23:
              _context7.next = 25;
              return call(get_access_token, payload);
            case 25:
              _backData = _context7.sent;
              if (_backData.success) {
                _context7.next = 30;
                break;
              }
              BossMessage(false, _backData.result);
              _context7.next = 34;
              break;
            case 30:
              _context7.next = 32;
              return call(_send_code, {
                access_token: _backData.access_token
              });
            case 32:
              _backData2 = _context7.sent;
              if (!_backData2.success) {
                BossMessage(false, _backData2.result);
              }
            case 34:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    update_2fa: function update_2fa(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(_update_2fa, payload);
            case 2:
              backData = _context8.sent;
              if (backData.success) {
                _context8.next = 7;
                break;
              }
              BossMessage(false, "操作失败:" + backData.result);
              _context8.next = 12;
              break;
            case 7:
              _context8.next = 9;
              return put({
                type: "update",
                payload: {
                  verify_channel: payload.verify_channel,
                  is_active: payload.is_active
                }
              });
            case 9:
              sessionStorage.setItem("verify_channel", payload.verify_channel);
              sessionStorage.setItem("is_active", payload.is_active);
              BossMessage(true, "操作成功");
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};